var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "img",
    width: 36,
    height: 36,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3b7bd7",
    d: "m 12,20 c 4.41,0 8,-3.59 8,-8 0,-4.41 -3.59,-8 -8,-8 -4.41,0 -8,3.59 -8,8 0,4.41 3.59,8 8,8 M 12,2 C 17.522847,2 22,6.4771525 22,12 22,17.522847 17.522847,22 12,22 6.477153,22 2,17.522847 2,12 2,6.4771525 6.477153,2 12,2 m 3.333333,14.5 -6,-4.5 6,-4.5 z",
    id: "path10"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b7bd7",
    d: "M 10.65628,7.5 H 8.658228 v 9 h 1.998052 v -9 H 8.658228 Z",
    id: "path362"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.bcf6a67dd82352696f6aba47667d1d0c.svg";
export { ForwardRef as ReactComponent };